import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';
import { safeAccessWithErrorHandler } from '../safe-access-with-error-handler';

const getLocalStorageItem = (key: string, errorHandler?: () => void) => {
	return safeAccessWithErrorHandler(() => AtlBrowserStorageLocal.getItem(key), errorHandler);
};

const setLocalStorageItem = (key: string, value: string, errorHandler?: () => void) => {
	return safeAccessWithErrorHandler(() => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		AtlBrowserStorageLocal.setItem(key, value);
	}, errorHandler);
};

const removeLocalStorageItem = (key: string, errorHandler?: () => void) => {
	return safeAccessWithErrorHandler(() => AtlBrowserStorageLocal.removeItem(key), errorHandler);
};

export { getLocalStorageItem, setLocalStorageItem, removeLocalStorageItem };
